import { connect } from 'react-redux';
import { State } from 'store/state';
import { activeInsightIdSelector } from 'store/state/insightsContext/selectors';
import CityPage from './CityPage';
import {
  resolvedLocalPageSelector,
  resolvedStrictLocalDocSelector,
  searchListTotalSelector,
  localPageMadadAgenciesCardsSelector,
  isSearchListLoadingSelector,
} from 'store/state/domainData/selectors';
import { listingPoiSelector } from 'store/state/selectors/searchListView';
import { routeSelector } from 'store/state/selectors/router';
import { flow } from 'lodash';
import { strictLocalDocSelector } from 'store/state/domainData/selectors/common';
import { pricesItemsCountSelector } from 'store/state/selectors/insights/prices';
import { articlesSelector } from 'components/blog-carousel/area-page';
import { leadingAgentsByDocIdsSelector } from 'store/state/domainData/selectors/searchAgentAwardsByDocIds';
import { LeadingAgentFeature } from 'utils/entities';
import { ilSchoolsDataSelector } from 'store/state/selectors/insights/schools';

const cityDocIdSelector = flow(
  strictLocalDocSelector,
  (doc): string => {
    if (!(doc && doc.data && doc.data && doc.data.docId2Information && doc.data.docId2Information.document && doc.data.docId2Information.document.hierarchyLevel)) return null;
    const city = doc.data.docId2Information.document.hierarchyLevel.find((item) => item.text === doc.data.docId2Information.document.city);
    return city && city.docId ? city.docId : null;
  }
);

const mapStateToProps = (state: State) => ({
  cityDocId: cityDocIdSelector(state),
  localData: resolvedLocalPageSelector(state),
  schoolsData: ilSchoolsDataSelector(state),
  activeInsightId: activeInsightIdSelector(state),
  poi: listingPoiSelector(state),
  total: searchListTotalSelector(state),
  route: routeSelector(state),
  searchArea: resolvedStrictLocalDocSelector(state),
  isSearchLoading: isSearchListLoadingSelector(state),
  pricesItemsCount: pricesItemsCountSelector(state),
  madadAgencies: localPageMadadAgenciesCardsSelector(state),
  articles: articlesSelector(state),
  leadingAgents: leadingAgentsByDocIdsSelector(state, LeadingAgentFeature.InfoPagesCarrousel),
});

export default connect(mapStateToProps)(CityPage);
